import { Slot } from '@radix-ui/react-slot';
import classNames from 'classnames';
import { isNull } from 'lodash-es';
import type { DOMAttributes, PropsWithChildren } from 'react';
import { Children, createContext, useContext } from 'react';


type ApplicationItemProps = {
  displayName: DOMAttributes<unknown>['dangerouslySetInnerHTML'];
  iconUrl: string;
};

const ApplicationItemContext = createContext<ApplicationItemProps | null>(null);

export const ApplicationItem = {
  Root({ iconUrl, displayName, children, className }: PropsWithChildren<ApplicationItemProps> & {className?: string}) {
    const Comp = (Children.count(children) > 0) ? Slot : 'div';

    return (
      <ApplicationItemContext.Provider value={{ iconUrl, displayName }}>
        <Comp className={classNames('flex flex-col items-center gap-50 tds-application-dropdown-item', className)}>
          {children ?? <ApplicationItemInternal iconUrl={iconUrl} displayName={displayName} /> }
        </Comp>
      </ApplicationItemContext.Provider>
    );
  },

  Content() {
    const context = useContext(ApplicationItemContext);

    if (isNull(context)) {
      return null;
    }

    return (
      <ApplicationItemInternal iconUrl={context.iconUrl} displayName={context.displayName} />
    );
  },
};

const ApplicationItemInternal = ({ displayName, iconUrl }: ApplicationItemProps) => {
  return (
    <>
      <img className=" w-500 h-500 p-100 box-content" src={iconUrl} aria-hidden alt="" />
      <span className="text-center tds-application-label" dangerouslySetInnerHTML={displayName} />
    </>
  );
};
